var _defs, _circle, _circle2, _path, _circle3, _circle4, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 437.99 83.27"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cart_svg__cls-1{stroke:#4c4c4c}.cart_svg__cls-1,.cart_svg__cls-3,.cart_svg__cls-4{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px}.cart_svg__cls-6{fill:#ffd14f;mix-blend-mode:darken}.cart_svg__cls-3{stroke:#abd4c0}.cart_svg__cls-4{stroke:#ffd14f}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "cart_svg__Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cart_svg__Accueil"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cart_svg__COMMENT_CA_MARCHE_",
    "data-name": "COMMENT CA MARCHE ?"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cart_svg__cls-6",
    cx: 425.04,
    cy: 77.31,
    r: 5.97
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cart_svg__cls-6",
    cx: 388.72,
    cy: 77.31,
    r: 5.97
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cart_svg__cls-6",
    d: "M429.08 56.89h-44.15c-.98 0-1.84-.66-2.09-1.62l-6.75-25.9c-.36-1.37.68-2.7 2.09-2.7h57.64c1.41 0 2.45 1.34 2.09 2.7l-6.75 25.9a2.17 2.17 0 0 1-2.09 1.62Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 384.57,
    y: 3.6,
    width: 40.88,
    height: 40.88,
    rx: 10,
    ry: 10,
    transform: "rotate(9.46 405.13 24.036)",
    style: {
      fill: "#abd4c0",
      mixBlendMode: "darken"
    }
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cart_svg__cls-1",
    cx: 420.76,
    cy: 73.31,
    r: 5.97
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cart_svg__cls-1",
    cx: 384.45,
    cy: 73.31,
    r: 5.97
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cart_svg__cls-1",
    d: "m378.99 52.61-4.83 3.55v6.61h57.9M426.47 52.61h-47.48l-7.88-30.22h63.23l-7.87 30.22zM371.11 22.39l-3.55-11.68-12.7-7.62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cart_svg__cls-3",
    d: "m281.85 40.39-28.03 28.03 10.85 10.85 38.89-38.88L264.67 1.5l-10.85 10.85 28.03 28.04z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cart_svg__cls-4",
    d: "M29.53 40.39 1.5 68.42l10.85 10.85 38.89-38.88L12.35 1.5 1.5 12.35l28.03 28.04z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#ef9f99",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    },
    d: "m153.21 40.39-28.03 28.03 10.85 10.85 38.89-38.88L136.03 1.5l-10.85 10.85 28.03 28.04z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cart_svg__cls-3",
    d: "M91.37 40.39 63.34 68.42l10.85 10.85 38.89-38.88L74.19 1.5 63.34 12.35l28.03 28.04z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cart_svg__cls-4",
    d: "M217.53 40.39 189.5 68.42l10.85 10.85 38.89-38.88L200.35 1.5 189.5 12.35l28.03 28.04z"
  })))))));
};
export default SvgCart;